import isEqual from 'lodash/isEqual';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { options } from 'config/reactRedux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import InputText from 'components/form/inputText';
import createGetTranslation from 'selectors/i18n';
import I18n from 'components/i18n';

import styles from './searchField.css';

class SearchField extends Component {
  state = {
    searchParam: this.props.params.s,
  };

  UNSAFE_componentWillReceiveProps({ params }) {
    if (!isEqual(this.props.params, params)) {
      this.setState({ searchParam: params.s });
    }
  }

  onInputChange = (e) => {
    this.setState({ searchParam: e.target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();

    // Auto-hide mobile, software keyboards
    const blurElement = e.currentTarget[0];
    blurElement.focus();
    blurElement.blur();

    const { params, onSubmit } = this.props;
    const { searchParam } = this.state;
    if (searchParam.trim()) {
      onSubmit({ ...params, s: searchParam });
    }
  };

  render() {
    const { getTranslation } = this.props;

    return (
      <div className={styles.wrapper}>
        <form className={styles.form} onSubmit={this.onSubmit}>
          <InputText
            name="search"
            className={styles.input}
            label="Search"
            type="search"
            placeholder={getTranslation('search', 'Search')}
            value={this.state.searchParam}
            onChange={this.onInputChange}
            shouldHideLabel
          />
          <a className={styles.buttonContainer}>
            <button className={styles.submit} type="submit">
              <I18n
                field="search"
                defaultText="Search"
              />
            </button>
          </a>
        </form>
      </div>
    );
  }
}

SearchField.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  getTranslation: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => ({
  getTranslation: createGetTranslation(state),
});

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);
const wrapWithStyles = withStyles(styles);

export default withRedux(wrapWithStyles(SearchField));
